<template>
    <EdsAccordion>
        <EdsAccordionItem>
            <template #title>
                <div class="d-flex justify-between mb-0-5">
                    <p>Page content</p>
                    <EdsTooltip class="action" :data="'Add section'" :position="'left'">
                        <i class="icon icon-plus" @click="sections.push({})"></i>
                    </EdsTooltip>
                </div>
            </template>
            <template #content>
                <EdsDropArea v-if="sections.length > 0" @reorder="reorderSections">
                    <EditPageSection
                        v-for="(section, index) in sections" 
                        :key="getSectionKey(section)" 
                        :section="section" 
                        :index="index" 
                        @deleteSection="deleteSection(index)"
                        ></EditPageSection>
                </EdsDropArea>
                <div v-else class="text-center">
                    <p>No sections added to this page.</p>
                </div>
            </template>
        </EdsAccordionItem>
    </EdsAccordion>
</template>
<script>
import EdsTile from '@/components/base.component/EdsTile.vue';
import EdsTooltip from '@/components/base.component/EdsTooltip.vue';
import EditPageSection from '@/components/complex.component/EditPageSection.vue';
import EdsDropArea from '@/components/base.component/EdsDropArea.vue';
import EdsAccordion from '@/components/base.component/EdsAccordion.vue';
import EdsAccordionItem from '@/components/base.component/EdsAccordionItem.vue';

export default {
    components: {
        EdsTile,
        EdsTooltip,
        EditPageSection,
        EdsDropArea,
        EdsAccordion,
        EdsAccordionItem
    },
    props: {
        sections: {
            type: Array,
            required: true
        }
    },
    methods: {
        deleteSection(index) {
            this.sections.splice(index, 1);
        },
        reorderSections(indexes) {
            this.$emit('reorder', indexes.map(i => this.sections[i.index]));
        },
        getSectionKey(section) {
            return section.svgContent;
        }
    }
}
</script>
<style lang="less" scoped>
@import '~@/assets/common.less';

.accordion {
    padding-right: @space-base;
}

.drop-area {
    margin-top: @space-large;
}
</style>